module.exports = __webpack_public_path__ + "img/upcommingEvents4.734fe620.jpg";